
import React from 'react';
import { FaFacebook, FaInstagram, FaEnvelope, FaWhatsapp, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>Mi Lugar</h3>
          <p>Centro de Día y Centro Educativo Terapéutico</p>
          <p>Fundado por la Lic. Mirtha Wechsung en 1982</p>
          <p>Más de 40 años de trayectoria</p>
        </div>

        <div className="footer-section">
          <h3>Sede Temperley</h3>
          <p><FaMapMarkerAlt /> A. Gallardo 646, Buenos Aires</p>
          <p><FaPhone /> 1165651675</p>
          <a href="https://wa.me/5491165651675" className="footer-link">
            <FaWhatsapp /> WhatsApp
          </a>
        </div>

        <div className="footer-section">
          <h3>Sede Glew</h3>
          <p><FaMapMarkerAlt /> RP210 Nº 22548, Buenos Aires</p>
          <p><FaPhone /> 1165661677</p>
          <a href="https://wa.me/5491165661677" className="footer-link">
            <FaWhatsapp /> WhatsApp
          </a>
        </div>

        <div className="footer-section">
          <h3>Síguenos</h3>
          <div className="social-icons">
            <a href="https://www.facebook.com/MiLugarTemperley" target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaFacebook />
            </a>
            <a href="https://www.instagram.com/cet.milugar/" target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaInstagram />
            </a>
            <a href="mailto:tulugar1@hotmail.com" className="social-icon">
              <FaEnvelope />
            </a>
          </div>
        </div>
      </div>

      <div className="copyright">
        <p>&copy; {new Date().getFullYear()} Mi Lugar - Todos los derechos reservados</p>
      </div>
    </footer>
  );
};

export default Footer;
